// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__mQ_FE","clinicsSelect":"TableHeading_clinicsSelect__3dMQ2"};